import React from 'react'
import { getContracts, Contract, deleteContract } from 'utils/ContractsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';

const ContractsGrid = () => {
  const columns = Contract.columns
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Contract"
  const getFormPath = () => import('components/Contracts/ContractsForm')

  return (
    selectedProject ?
      <Grid columns={columns} title={title} getRecords={getContracts} deleteRecord={deleteContract} selectedProject={selectedProject} component="Contracts" formPath={getFormPath}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 15, 25]
        }}
      /> : <SkeletonGrid title={title} />
  )
}

export default ContractsGrid